import React from 'react'
import WindowWithPrizes from './WindowWithPrizes'
import Button from './StyledComponents'

export default function ShowPrizes() {
    return (
        <div className="show-prizes">
            Prizes
            <WindowWithPrizes/>
        </div>
    )
}
